import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import isString from 'lodash-es/isString';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'wouter';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import Icon from '@panneau/element-icon';

var styles = {"container":"panneau-element-button-container","icon":"panneau-element-button-icon","withoutStyle":"panneau-element-button-withoutStyle","asLink":"panneau-element-button-asLink","withIcon":"panneau-element-button-withIcon","label":"panneau-element-button-label","right":"panneau-element-button-right","withIconColumns":"panneau-element-button-withIconColumns"};

var _excluded = ["type", "theme", "size", "href", "external", "direct", "target", "label", "children", "active", "underlined", "icon", "iconPosition", "disabled", "loading", "disableOnLoading", "withShadow", "withoutStyle", "withoutTheme", "asLink", "outline", "onClick", "className", "iconClassName", "labelClassName", "refButton"];
var propTypes = {
  type: PropTypes.string,
  theme: PropTypes$1.buttonTheme,
  size: PropTypes$1.buttonSize,
  href: PropTypes.string,
  external: PropTypes.bool,
  direct: PropTypes.bool,
  target: PropTypes.string,
  label: PropTypes$1.label,
  children: PropTypes$1.label,
  active: PropTypes.bool,
  underlined: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconPosition: PropTypes.oneOf(['left', 'right', 'inline']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  disableOnLoading: PropTypes.bool,
  withShadow: PropTypes.bool,
  withoutStyle: PropTypes.bool,
  withoutTheme: PropTypes.bool,
  outline: PropTypes.bool,
  asLink: PropTypes.bool,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  onClick: PropTypes.func,
  refButton: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any // eslint-disable-line
  })])
};
var defaultProps = {
  type: 'button',
  theme: null,
  size: null,
  href: null,
  external: false,
  direct: false,
  target: '_blank',
  label: null,
  children: null,
  active: false,
  underlined: false,
  icon: null,
  iconPosition: 'inline',
  disabled: false,
  loading: false,
  disableOnLoading: true,
  withShadow: false,
  withoutStyle: false,
  withoutTheme: false,
  outline: false,
  asLink: false,
  className: null,
  iconClassName: null,
  labelClassName: null,
  onClick: null,
  refButton: null
};
var Button = function Button(_ref) {
  var _ref8;
  var type = _ref.type,
    theme = _ref.theme,
    size = _ref.size,
    href = _ref.href,
    external = _ref.external,
    direct = _ref.direct,
    target = _ref.target,
    label = _ref.label,
    children = _ref.children,
    active = _ref.active,
    underlined = _ref.underlined,
    icon = _ref.icon,
    iconPosition = _ref.iconPosition,
    disabled = _ref.disabled,
    loading = _ref.loading,
    disableOnLoading = _ref.disableOnLoading,
    withShadow = _ref.withShadow,
    withoutStyle = _ref.withoutStyle,
    withoutTheme = _ref.withoutTheme,
    asLink = _ref.asLink,
    outline = _ref.outline,
    onClick = _ref.onClick,
    className = _ref.className,
    iconClassName = _ref.iconClassName,
    labelClassName = _ref.labelClassName,
    refButton = _ref.refButton,
    props = _objectWithoutProperties(_ref, _excluded);
  var finalLabel = label || children;
  var text = finalLabel !== null ? finalLabel : null;
  var hasChildren = label !== null && children !== null;
  var hasIcon = icon !== null;
  var hasInlineIcon = hasIcon && (iconPosition === 'inline' || text === null);
  var hasIconColumns = hasIcon && !hasInlineIcon;
  var finalIcon = isString(icon) ? /*#__PURE__*/React.createElement(Icon, {
    name: icon
  }) : icon;
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, hasInlineIcon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: classNames([styles.icon, _defineProperty({}, iconClassName, iconClassName !== null)])
  }, finalIcon), text !== null ? /*#__PURE__*/React.createElement("span", {
    className: classNames([styles.label, _defineProperty({}, labelClassName, labelClassName !== null)])
  }, text) : null) : null, hasIconColumns ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: classNames([styles.left, _defineProperty({}, iconClassName, iconClassName !== null && iconPosition === 'left')])
  }, iconPosition === 'left' ? finalIcon : null), /*#__PURE__*/React.createElement("span", {
    className: classNames([styles.center, _defineProperty({}, labelClassName, labelClassName !== null)])
  }, text), /*#__PURE__*/React.createElement("span", {
    className: classNames([styles.right, _defineProperty({}, iconClassName, iconClassName !== null && iconPosition === 'right')])
  }, iconPosition === 'right' ? finalIcon : null), hasChildren ? children : null) : null, !hasIcon ? text : null, hasChildren ? children : null);
  var withStyle = !withoutTheme && !withoutStyle && !asLink;
  var buttonClassNames = classNames([_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    btn: withStyle
  }, "btn-".concat(outline ? 'outline-' : '').concat(theme), withStyle && theme !== null), "btn-".concat(size), withStyle && size !== null), "text-decoration-underline", !withoutStyle && underlined), "active", !withoutStyle && active), styles.container, (_ref8 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref8, styles.withoutStyle, withoutStyle), styles.withIcon, hasIcon), styles.withIconColumns, hasIconColumns), styles.withText, text !== null), styles.withShadow, withShadow), styles.isLink, href !== null), styles.asLink, asLink), styles.isDisabled, disabled), styles.isLoading, loading), styles.active, !withoutStyle && active), _defineProperty(_ref8, className, className !== null))]);
  if (href !== null && !disabled) {
    return external || direct ? /*#__PURE__*/React.createElement("a", Object.assign({}, props, {
      href: href,
      className: buttonClassNames,
      onClick: onClick,
      target: external ? target : null,
      ref: refButton
    }), content) : /*#__PURE__*/React.createElement(Link, {
      href: href,
      onClick: onClick,
      className: buttonClassNames,
      ref: refButton
    }, content);
  }
  return /*#__PURE__*/React.createElement("button", Object.assign({}, props, {
    type: type,
    className: buttonClassNames,
    onClick: onClick,
    disabled: disabled || disableOnLoading && loading,
    ref: refButton
  }), content);
};
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export { Button as default };
